import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";

import "./stepper.scss";
import StepperSteps from "./StepperSteps";

const Stepper = ({
  steps,
  stepCount,
  children,
  setCurrentStep,
  currentStep,
  isDesktop,
  useApplicationTrackingUI,
}) => {
  return (
    <>
      <StepperSteps
        steps={steps}
        stepCount={stepCount}
        currentStep={currentStep}
        onSetCurrentStep={setCurrentStep}
        isDesktop={isDesktop}
        useApplicationTrackingUI={useApplicationTrackingUI}
      />
      <section className="turing-job-stepper-pages">
        {children}
      </section>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({ dispatch });
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Stepper);
